"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var client_lib_js_player_framework_utils_1 = require("@sky-uk-ott/client-lib-js-player-framework-utils");
var KEY_CODE_MAP = (_a = {},
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.UP] = [38],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.DOWN] = [40],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.LEFT] = [37],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RIGHT] = [39],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.ENTER] = [13],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.BACK] = [27],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.DELETE] = [8],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.FF] = [33],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RW] = [34],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.PLAY] = [32],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.PAUSE] = [80],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.STOP] = [83],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.RED] = [82],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.GREEN] = [71],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.YELLOW] = [66],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.BLUE] = [89],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.INFO] = [73],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.AD] = [112],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SEARCH] = [113],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SUBTITLES] = [114],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.HELP] = [115],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SKIP_PREV] = [118],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SKIP_NEXT] = [120],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[1]] = [49],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[2]] = [50],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[3]] = [51],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[4]] = [52],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[5]] = [53],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[6]] = [54],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[7]] = [55],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[8]] = [56],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[9]] = [57],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY[0]] = [48],
    _a[client_lib_js_player_framework_utils_1.CTV_KEY.SHORTCUT_9] = [32],
    _a);
var PREVENT_DEFAULT = new Set([27, 37, 38, 39, 40, 13]);
var BrowserInput = (function (_super) {
    __extends(BrowserInput, _super);
    function BrowserInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.keyCodeMap = KEY_CODE_MAP;
        _this.preventDefault = PREVENT_DEFAULT;
        return _this;
    }
    return BrowserInput;
}(client_lib_js_player_addons_common_player_1.Input));
exports.BrowserInput = BrowserInput;
